/**
 * 新增表单时，根据当前登录用户匹配经办人下拉选项。
 * @param {Array} employeeList 员工列表（不含「全部」选项）
 * @param {string} loginUserName LoginUser 接口返回的 name
 * @returns {string|number|null} 匹配到的员工 id；匹配不到则返回 ""（全部）
 */
export function getDefaultLeaderId(employeeList, loginUserName) {
  if (!loginUserName || !employeeList || !employeeList.length) {
    return "";
  }
  const matched = employeeList.find((item) => item.name === loginUserName);
  return matched ? matched.id : "";
}
